import React, {
    useEffect, useState, useCallback, Fragment,
} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Cookies from 'universal-cookie';
import _ from 'lodash';
import { useParams, useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import format from 'date-fns/format';
import { Checkbox, Container } from '@material-ui/core';
import DialogContentText from '@material-ui/core/DialogContentText';
import { FormattedMessage, useIntl } from 'react-intl';
import CustomTable from '../../components/Table/Table';
import Button from '../../components/Button/CustomButton';
import GridItem from '../../components/Grid/GridItem';
import AlertDialog from '../../components/Dialog/AlertDialog';
import Snackbar from '../../components/Snackbar/Snackbar';
import styles from '../../assets/jss/pages/productManagementPageStyle';
import CustomTypography from '../../components/Typography/CustomTypography';
import GridContainer from '../../components/Grid/GridContainer';
import CleanableInput from '../../components/Input/CleanableInput';
import SingleDatePickerSearch from '../../components/DatePicker/SingleDatePickerSearch';
import Loader from '../../components/Loader/Loader';
import dateUtils, { convertDuration } from '../../utils/dateUtils';
import { navyColor } from '../../assets/jss/global';
import ViewHeader from '../../components/Header/ViewHeader';
import { SEMINAR_STATUS_TEXT } from '../../common/Constants';
import {
    LoadMoreIcon,
} from '../../components/Icons/Icon';
import SeminarPayment from './SeminarPayment';
import ConfirmDialog from '../../components/Dialog/ConfirmDialog';
import ListSeminarViewerCustomLayout from './ListSeminarViewerCustomLayout';
import { platform, PLATFORM } from '../../utils/getPlatform';

const useStyles = makeStyles(styles);

export const Header = (props) => {
    const { eventInfo } = props;
    const intl = useIntl();
    return (
        <>
            {!_.isEmpty(eventInfo) && (
                <ViewHeader
                    eventName={eventInfo.name}
                    title={eventInfo?.settings_texts_sidebar_viewer?.field_name?.seminar_list || intl.formatMessage({ id: 'userRoutes.seminarList' })}
                    eventInfo={eventInfo}
                />
            )}
        </>
    );
};

Header.defaultProps = {
    eventInfo: {},
};

Header.propTypes = {
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
};

const ListSeminarViewer = (props) => {
    const {
        listPagination,
        registerSeminarRequested,
        clearRegisterSeminar,
        fetchListSeminarViewer,
        listSeminarViewer,
        clearListSeminarViewer,
        isLoading,
        registerStatus,
        idRegister,
        eventInfo,
        isWeakAuth,
        isAuthorized,
        errorRegister,
        customText,
        customColor,
        locale,
        language,
        langOther,
    } = props;
    const classes = useStyles(props);
    const routeParams = useParams();
    const intl = useIntl();
    const history = useHistory();
    const [listSeminarViewerResult, setListSeminarViewerResult] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [showSearch, setShowSearch] = useState(false);
    const [totalPage, setTotalPage] = useState(1);
    const [registerCheck, setRegisterCheck] = useState({});
    const [isOpenConfirmDialog, setIsOpenConfirmDialog] = useState({ open: false, content: '' });
    const [snackbar, setSnackbar] = useState({ isOpen: false, type: 'success', message: '' });
    const [params, setParams] = useState({ startDate: '', endDate: '', seminarTitle: '' });
    const [openDialogDetail, setOpenDialogDetail] = useState(false);
    const [isOpenConfirmSuccess, setIsOpenConfirmSuccess] = useState({ open: false, content: '', success: false });

    useEffect(() => {
        const { shortName } = routeParams;
        clearRegisterSeminar();
        if (params.endDate || params.startDate) {
            fetchListSeminarViewer({
                event_name: shortName,
                sdate: params.startDate ? format(new Date(params.startDate), 'yyyy-MM-dd') : '',
                edate: params.endDate ? format(new Date(params.endDate), 'yyyy-MM-dd') : '',
                language: locale,
            });
        } else {
            fetchListSeminarViewer({
                event_name: shortName,
                language: locale,
            });
        }
        return () => {
            clearListSeminarViewer();
            clearRegisterSeminar();
        };
    }, [routeParams, locale]);

    useEffect(() => {
        setParams({ ...params, seminarTitle: '' });
    }, [locale]);

    useEffect(() => {
        if (langOther !== 'English' && langOther !== '日本語' && langOther !== '') {
            setShowSearch(true);
        } else setShowSearch(false);
    }, [langOther]);

    useEffect(() => {
        if (listSeminarViewer) {
            setListSeminarViewerResult(listSeminarViewer);
        }
    }, [listSeminarViewer]);

    useEffect(() => {
        if (listPagination) {
            setCurrentPage(listPagination.page);
            setTotalPage(listPagination.total_page);
        }
    }, [listPagination]);

    useEffect(() => {
        if (!_.isEmpty(idRegister)) {
            if (registerStatus === false) {
                setSnackbar({
                    isOpen: true,
                    type: 'error',
                    message: intl.formatMessage({ id: 'seminar.errorRegister' }, {
                        namePage: eventInfo.settings_texts_sidebar_viewer?.field_name?.seminar_list
                        || intl.formatMessage({ id: 'login.seminars' }).toLocaleLowerCase(),
                    }),
                });
            }
            if (registerStatus && !getRegisterCost()) {
                setIsOpenConfirmSuccess({ open: true, content: intl.formatMessage({ id: 'common.completeApplication' }), success: true });
            } else if (registerStatus && params.payment_method && getRegisterCost()) {
                handleCloseDialogDetail();
                if (+params.payment_method === 1) {
                    setIsOpenConfirmSuccess({
                        open: true,
                        content: intl.formatMessage({ id: 'common.completeApplication' }),
                        success: true,
                    });
                } else if (+params.payment_method === 2) {
                    setIsOpenConfirmSuccess({
                        open: true,
                        content: getContent(),
                        success: true,
                    });
                }
            }
            clearRegisterSeminar();
        }
    }, [idRegister]);

    useEffect(() => {
        if (!_.isEmpty(errorRegister)) {
            setIsOpenConfirmSuccess({
                open: true,
                content: errorRegister?.message?.message,
                success: false,
            });
        }
    }, [errorRegister]);

    const getContent = () => (
        <>
            <DialogContentText style={{ textAlign: 'left', color: customColor?.contents_text_color }}>
                {intl.formatMessage({ id: 'common.completeApplication' })}
            </DialogContentText>
            <DialogContentText style={{ textAlign: 'left', color: customColor?.contents_text_color }}>
                {intl.formatMessage({ id: 'common.emailBillDetail' })}
            </DialogContentText>
            <DialogContentText style={{ textAlign: 'left', color: customColor?.contents_text_color }}>
                {intl.formatMessage({ id: 'common.confirm' })}
            </DialogContentText>
            <DialogContentText style={{ textAlign: 'left', color: customColor?.contents_text_color }}>
                {intl.formatMessage({ id: 'common.sendMoney' })}
            </DialogContentText>
        </>
    );

    const createDataView = () => {
        const viewTotal = [];
        (Object.keys(listSeminarViewerResult).forEach((key) => {
            createDateTitle(key);
            const viewTable = [];
            Object.keys(listSeminarViewerResult[key]).forEach((roomData) => {
                const dataRow = [];
                const dataId = [];
                const registeredArray = [];
                const dataDateTime = [];
                const seminarStatusArray = [];
                if (listSeminarViewerResult[key][roomData]) {
                    listSeminarViewerResult[key][roomData].forEach((seminar) => {
                        const utcDateNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Tokyo' }));
                        const costPaid = seminar.cost > 0
                            ? `${intl.formatNumber(seminar.cost)}${intl.formatMessage({ id: 'common.yen' })}`
                            : intl.formatMessage({ id: 'common.free' });
                        const yearStart = +seminar.date.split('-')[0];
                        const mouthStart = +seminar.date.split('-')[1];
                        const dayStart = +seminar.date.split('-')[2];
                        const hourStart = +seminar.stime.split(':')[0];
                        const minutesStart = +seminar.stime.split(':')[1];
                        const hourEnd = +seminar.etime.split(':')[0];
                        const minutesEnd = +seminar.etime.split(':')[1];
                        const timeRunningStartNew = new Date(yearStart, mouthStart - 1, dayStart, hourStart, minutesStart);
                        const timeRunningEndNew = new Date(yearStart, mouthStart - 1, dayStart, hourEnd, minutesEnd);
                        const isActiveBeforeStart = utcDateNow <= new Date(timeRunningStartNew.setDate(timeRunningStartNew.getDate() - 30));
                        const isActiveAfterEnd = utcDateNow >= new Date(timeRunningEndNew.setDate(timeRunningEndNew.getDate() + 30));
                        const seminarDisable = isActiveBeforeStart || isActiveAfterEnd;
                        const disableCheckBox = seminar.registered ? { color: '#00000042' } : { color: eventInfo?.settings_colors_viewer?.button_background_color?.common_button };
                        dataRow.push([
                            ...((!eventInfo.free_seminar && isAuthorized && isWeakAuth === '') ? [
                                <Checkbox
                                    disabled={seminarDisable}
                                    checked={(registerCheck[seminar.id] && registerCheck[seminar.id][seminar.id]) || seminar.registered}
                                    onChange={(e) => handleRegisterCheck(e, seminar.id, seminar.cost, seminar.title)}
                                    onClick={(e) => e.stopPropagation()}
                                    style={disableCheckBox}
                                />,
                            ] : []),
                            `${seminar.stime}~${seminar.etime}`,
                            seminar.title,
                            seminar.content,
                            seminar.speaker,
                            SEMINAR_STATUS_TEXT[locale][seminar.status],
                            costPaid,
                            convertDuration(
                                seminar.media_duration,
                                intl.formatMessage({ id: 'common.hour' }),
                                intl.formatMessage({ id: 'common.minute' }),
                                intl.formatMessage({ id: 'common.second' }),
                            ),
                        ]);
                        dataId.push(seminar.id);
                        registeredArray.push(seminar.registered);
                        dataDateTime.push({ date: seminar.date, stime: seminar.stime, etime: seminar.etime });
                        seminarStatusArray.push(seminar.is_paused);
                    });
                }
                viewTable.push(createTable(roomData, dataRow, dataId, dataDateTime, registeredArray, seminarStatusArray));
            });
            const viewDate = (
                <>
                    {createDateTitle(key)}
                    {viewTable}
                </>
            );
            viewTotal.push(viewDate);
        }));
        return viewTotal;
    };

    const createDateTitle = (dateTitle) => (
        <GridItem xs={12} style={{ margin: '20px 0 20px 0' }}>
            <CustomTypography bold variant="h5" customColor={customColor?.contents_text_color}>
                {intl.formatMessage({ id: 'common.date' })}
                {'  :  '}
                {dateUtils.formatJa(new Date(dateTitle), locale)}
            </CustomTypography>
        </GridItem>

    );

    const createCustomList = () => (
        <ListSeminarViewerCustomLayout
            listData={listSeminarViewerResult}
            customColor={customColor}
            customText={customText}
            handleOpenDetail={handleOpenDetail}
            isAuthorized={isAuthorized}
            isWeakAuth={isWeakAuth}
            handleRegisterCheck={handleRegisterCheck}
            registerCheck={registerCheck}
            eventInfo={eventInfo}
            locale={locale}
        />
    );

    const createTable = (title, dataRow, dataId, dataDateTime, registeredArray, seminarStatusArray) => {
        const tableHeaders = [
            customText?.field_name?.application_check || intl.formatMessage({ id: 'seminar.applicationCheck' }),
            customText?.field_name?.time || intl.formatMessage({ id: 'common.time1' }),
            customText?.field_name?.lecture_name || intl.formatMessage({ id: 'seminar.lectureName' }),
            customText?.field_name?.lecture_content || intl.formatMessage({ id: 'seminar.lectureContent' }),
            customText?.field_name?.speaker || intl.formatMessage({ id: 'seminar.speaker' }),
            customText?.field_name?.situation || intl.formatMessage({ id: 'status' }),
            customText?.field_name?.price || intl.formatMessage({ id: 'price' }),
            customText?.field_name?.playback_time || intl.formatMessage({ id: 'seminar.playTime' }),
        ];
        let tableHeaderWidth = ['10%', '10%', '10%', '25%', '15%', '10%', '10%', '10%'];
        if (!(!eventInfo.free_seminar && isAuthorized && isWeakAuth === '')) {
            tableHeaders.shift();
            tableHeaderWidth = ['10%', '10%', '25%', '20%', '10%', '10%', '10%'];
        }
        return (
            <GridItem xs={12}>
                <CustomTypography
                    variant="subtitle1"
                    bold
                    customColor={customColor?.contents_text_color}
                >
                    <li>
                        {intl.formatMessage({ id: 'common.conferenceRoom' })}
                        {' '}
                        {title}
                    </li>
                </CustomTypography>
                <CustomTable
                    cellTextColorHear={customColor?.list_table?.title_text_color}
                    cellTextColorBody={customColor?.contents_text_color}
                    cellBackgroundColor={customColor?.list_table}
                    onClick={(index) => handleOpenDetail(dataId[index], dataDateTime[index], registeredArray[index], seminarStatusArray[index])}
                    tableHead={tableHeaders}
                    tableHeadWidth={tableHeaderWidth}
                    tableData={dataRow}
                    cellColor={customColor?.list_table?.title_background_color || navyColor}
                />
            </GridItem>
        );
    };

    const handleOpenDetail = (idSeminar, dataDateTime, isRegistered, paused) => {
        const { shortName } = routeParams;
        const utcDateNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Tokyo' }));
        const yearStart = +dataDateTime.date.split('-')[0];
        const mouthStart = +dataDateTime.date.split('-')[1];
        const dayStart = +dataDateTime.date.split('-')[2];
        const hourStart = +dataDateTime.stime.split(':')[0];
        const minutesStart = +dataDateTime.stime.split(':')[1];
        const hourEnd = +dataDateTime.etime.split(':')[0];
        const minutesEnd = +dataDateTime.etime.split(':')[1];
        const timeRunningStart = new Date(yearStart, mouthStart - 1, dayStart, hourStart, minutesStart);
        const timeRunningEnd = new Date(yearStart, mouthStart - 1, dayStart, hourEnd, minutesEnd);
        const dateBeforeSeminarView = utcDateNow < new Date(timeRunningStart.setDate(timeRunningStart.getDate() - 30));
        const isActiveAfterEnd30Day = utcDateNow >= new Date(timeRunningEnd.setDate(timeRunningEnd.getDate() + 30));
        const beforeMessage = intl.formatMessage({ id: 'seminar.errorViewOneMonth' }, {
            name: eventInfo.settings_texts_sidebar_viewer?.field_name?.seminar_list
            || intl.formatMessage({ id: 'home.seminar' }).toLocaleLowerCase(),
            namePage: eventInfo?.settings_texts_sidebar_viewer?.field_name?.seminar_list
            || intl.formatMessage({ id: 'userRoutes.seminarList' }).toLocaleLowerCase(),
        });
        const afterMessage = intl.formatMessage({ id: 'seminar.errorOneMonth' });
        if (paused) {
            setSnackbar({
                ...snackbar,
                isOpen: true,
                type: 'error',
                message: intl.formatMessage({ id: 'seminar.noViewSeminar' }, {
                    name: eventInfo.settings_texts_sidebar_viewer?.field_name?.seminar_list || intl.formatMessage({ id: 'home.seminar' }),
                }),
            });
        } else if (!dateBeforeSeminarView && !isActiveAfterEnd30Day) {
            const { pathname } = history.location;
            let path = `${pathname}/${idSeminar}`;
            if (isRegistered) {
                path = `/${shortName}/seminar_registered/${idSeminar}`;
            }
            history.push(path);
        } else {
            setSnackbar({
                ...snackbar,
                isOpen: true,
                type: 'error',
                message: isActiveAfterEnd30Day ? afterMessage : beforeMessage,
            });
        }
    };

    const handleSearch = () => {
        const { shortName } = routeParams;
        clearListSeminarViewer();
        fetchListSeminarViewer({
            event_name: shortName,
            sdate: params.startDate ? format(new Date(params.startDate), 'yyyy-MM-dd') : '',
            edate: params.endDate ? format(new Date(params.endDate), 'yyyy-MM-dd') : '',
            title: params.seminarTitle ? params.seminarTitle.trim() : '',
            language: locale,
        });
    };

    const handleSetParams = useCallback((field, value) => {
        setParams((prevParams) => ({ ...prevParams, [field]: value }));
    }, []);

    const handleRegisterCheck = (e, seminar_id, cost, title) => {
        setRegisterCheck({ ...registerCheck, [seminar_id]: { [seminar_id]: e.target.checked, price: cost, titleSeminar: title } });
    };
    const getRegisterId = () => {
        const total = [];
        Object.keys(registerCheck).forEach((id) => {
            if (registerCheck[id][id]) {
                total.push(+id);
            }
        });
        return total;
    };

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, isOpen: false });
    };

    const handleShowConfirmDialog = () => {
        if (registerCheck && getRegisterId().length > 0) {
            setIsOpenConfirmDialog({
                open: true,
                content: eventInfo?.settings_texts_sidebar_viewer?.field_name?.seminar_list
                    ? intl.formatMessage({ id: 'seminar.register' })
                    : intl.formatMessage({ id: 'seminar.registerSeminar' }, {
                        name: eventInfo.settings_texts_sidebar_viewer?.field_name?.seminar_list
                        || intl.formatMessage({ id: 'login.seminars' }).toLocaleLowerCase(),
                    }),
            });
        } else {
            setSnackbar({
                ...snackbar,
                isOpen: true,
                type: 'error',
                message: intl.formatMessage({ id: 'seminar.selectLeast' }, {
                    name: eventInfo.settings_texts_sidebar_viewer?.field_name?.seminar_list
                    || intl.formatMessage({ id: 'home.seminar' }).toLocaleLowerCase(),
                }),
            });
            handleCloseConfirmDialog();
        }
    };
    const handleCloseConfirmDialog = () => {
        setIsOpenConfirmDialog({ open: false, content: '' });
    };

    const handleLoadMore = () => {
        const { shortName } = routeParams;
        fetchListSeminarViewer({ event_name: shortName, page: currentPage + 1, language: locale });
    };

    const handleRegisterSeminar = () => {
        let dataSubmit;
        if (!getRegisterCost()) {
            dataSubmit = {
                seminar_ids: getRegisterId(),
            };
            registerSeminarRequested({ data: dataSubmit, language: locale });
        }
    };

    const handleCloseDialogDetail = () => {
        setOpenDialogDetail(false);
    };

    const getRegisterCost = () => {
        let totalPrice = 0;
        Object.keys(registerCheck).forEach((id) => {
            if (registerCheck[id][id]) {
                totalPrice += registerCheck[id].price;
            }
        });
        return totalPrice;
    };

    const handleDialogRegisterSeminar = () => {
        if (!getRegisterCost()) {
            setIsOpenConfirmDialog({ open: false, content: '' });
            handleRegisterSeminar();
        } else if (getRegisterId().length > 0 && getRegisterCost()) {
            setOpenDialogDetail(true);
            setIsOpenConfirmDialog({ open: false, content: '' });
        } else {
            setSnackbar({
                ...snackbar,
                isOpen: true,
                type: 'error',
                message: intl.formatMessage({ id: 'seminar.selectLeast' }, {
                    name: eventInfo.settings_texts_sidebar_viewer?.field_name?.seminar_list
                    || intl.formatMessage({ id: 'home.seminar' }).toLocaleLowerCase(),
                }),
            });
        }
    };

    const handleSuccessDialog = () => {
        if (!isOpenConfirmSuccess.success) {
            setIsOpenConfirmSuccess({ open: false, content: '', success: false });
        } else {
            const cookies = new Cookies();
            const { shortName } = routeParams;
            cookies.set('tabSelect', 3, { path: '/' });
            history.push(`/${shortName}/seminar_registered`);
        }
    };

    const designSearchSeminar = () => (
        <>
            <GridContainer style={{ marginTop: '20px' }}>
                <GridItem xs={12} sm={6} md={7} className={classes.inputTitle}>
                    <CustomTypography bold className={classes.searchLabel} customColor={customColor?.contents_text_color}>
                        {intl.formatMessage({ id: 'common.date' })}
                    </CustomTypography>
                </GridItem>
                <GridItem xs={12} sm={6} md={5} className={classes.dateRangeSearch}>
                    <SingleDatePickerSearch
                        onChange={(startDate) => handleSetParams('startDate', startDate)}
                        defaultValue={null}
                    />
                    <span className={classes.dateRangeArea}>〜</span>
                    <SingleDatePickerSearch
                        onChange={(endDate) => handleSetParams('endDate', endDate)}
                        defaultValue={null}
                    />
                </GridItem>
            </GridContainer>
            <GridContainer style={{ marginTop: '20px' }}>
                <GridItem xs={12} sm={6} md={7} className={classes.inputTitle}>
                    <CustomTypography bold style={{ marginTop: '10px' }} className={classes.searchLabel} customColor={customColor?.contents_text_color}>
                        {customText?.field_name?.lecture_name || intl.formatMessage({ id: 'seminar.lectureName' })}
                    </CustomTypography>
                </GridItem>
                <GridItem xs={12} sm={6} md={5} style={{ paddingLeft: '8px' }}>
                    <CleanableInput
                        classes={{ root: classes.colorTextInput }}
                        className={classes.input}
                        size="small"
                        defaultValue={params.seminarTitle}
                        placeholder={intl.formatMessage({ id: 'seminar.placeholderSearch' }, {
                            courseContent: customText?.field_name?.lecture_name || intl.formatMessage({ id: 'seminar.lectureName' }).toLocaleLowerCase(),
                        })}
                        onChange={(value) => handleSetParams('seminarTitle', value)}
                    />
                </GridItem>
            </GridContainer>
            <GridContainer>
                <GridItem xs={12} md={12} className={classes.buttonSearch}>
                    <Button
                        color="navy"
                        round
                        gradient
                        size="md"
                        onClick={() => handleSearch()}
                        buttonTextColor={customColor?.button_text_color}
                        buttonBackgroundColor={customColor?.button_background_color?.common_button}
                    >
                        <b>{customText?.button_name?.search_seminar || intl.formatMessage({ id: 'search' })}</b>
                    </Button>
                </GridItem>
            </GridContainer>
        </>
    );

    return (
        <>
            <Loader isLoading={isLoading} />
            <div>
                {!_.isEmpty(eventInfo) && (
                    <GridItem xs={12} className={classNames({ [classes.noPadding]: platform !== PLATFORM.OTHER && eventInfo.layout_seminar })}>
                        {!(eventInfo.layout_seminar && platform === PLATFORM.OTHER)
                            ? !showSearch && designSearchSeminar()
                            : (
                                !showSearch && <Container>{designSearchSeminar()}</Container>
                            )}
                        {!eventInfo.layout_seminar ? createDataView() : createCustomList()}
                        {currentPage < totalPage && (
                            <GridItem align="center" className={eventInfo.layout_seminar && classes.loadMore}>
                                <Button
                                    onClick={handleLoadMore}
                                    color="navy"
                                    gradient
                                    size="md"
                                    round
                                    buttonTextColor={customColor?.button_text_color}
                                    buttonBackgroundColor={customColor?.button_background_color?.common_button}
                                >
                                    <LoadMoreIcon />
                                    {intl.formatMessage({ id: 'common.seeMore' })}
                                </Button>
                            </GridItem>
                        )}
                        {!!(listPagination.total_length && isAuthorized && isWeakAuth === '' && !eventInfo.free_seminar) && (
                            <GridContainer
                                direction="row"
                                justify="center"
                                alignItems="center"
                            >
                                <Button
                                    color="navy"
                                    round
                                    gradient
                                    className={classes.buttonBig}
                                    onClick={() => handleShowConfirmDialog()}
                                    buttonTextColor={customColor?.button_text_color}
                                    buttonBackgroundColor={customColor?.button_background_color?.common_button}
                                >
                                    <b>{customText?.button_name?.seminar_application || intl.formatMessage({ id: 'registerViewer.applicationSeminar' })}</b>
                                </Button>
                            </GridContainer>
                        )}

                        {!listPagination.total_length && (
                            <GridItem
                                xs={12}
                                style={{
                                    textAlign: 'center',
                                    fontWeight: 'bold',
                                    fontSize: '20px',
                                    zIndex: 1,
                                    color: customColor?.contents_text_color,
                                }}
                            >
                                <FormattedMessage id="noData" />
                            </GridItem>
                        )}
                    </GridItem>
                )}
            </div>
            <SeminarPayment
                isOpen={openDialogDetail}
                handleClose={handleCloseDialogDetail}
                registerCheck={registerCheck}
                getRegisterCost={getRegisterCost()}
                eventInfo={eventInfo}
                registerSeminar={registerSeminarRequested}
                getTokenError={(value) => setIsOpenConfirmSuccess({ open: true, content: value, success: false })}
                payment={(value) => setParams({ ...params, payment_method: value })}
                customText={customText}
                customColor={customColor}
                locale={locale}
            />
            <Snackbar
                open={snackbar.isOpen}
                onClose={handleCloseSnackbar}
                message={snackbar.message}
                severity={snackbar.type}
            />
            <AlertDialog
                handleOpen={isOpenConfirmDialog.open}
                handleClose={handleCloseConfirmDialog}
                handleSubmit={handleDialogRegisterSeminar}
                contents={isOpenConfirmDialog.content}
                customColor={customColor}
            />
            <ConfirmDialog
                title={intl.formatMessage({ id: 'confirm' })}
                contents={isOpenConfirmSuccess.content}
                open={isOpenConfirmSuccess.open}
                handleClose={handleSuccessDialog}
                customColor={customColor}
            />
        </>
    );
};

ListSeminarViewer.defaultProps = {
    listSeminarViewer: [],
    idRegister: {},
    registerStatus: false,
    listPagination: {},
    eventInfo: {},
    isAuthorized: false || undefined,
    isWeakAuth: false || undefined,
    errorRegister: {},
    customText: {},
    customColor: {},
    locale: 'ja',
    language: 'ja',
    langOther: '',
};

ListSeminarViewer.propTypes = {
    fetchListSeminarViewer: PropTypes.func.isRequired,
    clearListSeminarViewer: PropTypes.func.isRequired,
    registerSeminarRequested: PropTypes.func.isRequired,
    clearRegisterSeminar: PropTypes.func.isRequired,
    listSeminarViewer: PropTypes.oneOfType([() => null, PropTypes.array]),
    isLoading: PropTypes.bool.isRequired,
    registerStatus: PropTypes.bool,
    idRegister: PropTypes.oneOfType([() => null, PropTypes.object]),
    listPagination: PropTypes.oneOfType([() => null, PropTypes.object]),
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    isAuthorized: PropTypes.oneOfType([() => PropTypes.string, PropTypes.bool]),
    isWeakAuth: PropTypes.oneOfType([() => PropTypes.string, PropTypes.bool]),
    errorRegister: PropTypes.oneOfType([() => null, PropTypes.object]),
    customText: PropTypes.oneOfType([() => null, PropTypes.object]),
    customColor: PropTypes.oneOfType([() => null, PropTypes.object]),
    locale: PropTypes.string,
    language: PropTypes.string,
    langOther: PropTypes.string,
};

export default ListSeminarViewer;
